/**
 * @file Route: pronetwork
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import Header from "components/Header/Pro";
import "components/Intro/dark";
import "components/Training";
import Recent from "components/Recent";
// import "components/Calendar";
import Signup from "components/Signup";
import "components/Box";
import "./index.scss";

console.log("Route pronetwork/index.js mounted.");

Header();
Recent();
Signup();
